import PreviewComponentLabel from './previewComponentLabel/PreviewComponentLabel';

const Input = ({
    label,
    isRequired,
    isEditable,
    attributes,
}: {
    label: string;
    isRequired: boolean;
    isEditable: boolean;
    attributes: { [key: string]: string };
}) => {
    return (
        <div data-testid="component-preview-input" className="component-preview-input">
            <PreviewComponentLabel labelText={label} isRequired={isRequired} />
            <input
                tabIndex={-1}
                type={attributes?.['$isSlider'] === 'true' ? 'range' : 'text'}
                disabled={!isEditable}
            />
        </div>
    );
};

export default Input;
